export const HTTP_STATUS_ERROR_CODES_CONSTANTS = {
  UNAUTHORIZED: 401
} as const;
